import { useRecoilValue, useSetRecoilState } from "recoil";
import { clearCredential } from "../utils/network";
import { GlobalOverlay } from "./style";
import * as S from "./style/logout";
import { loginState } from "../recoil/auth.atom";
import { useNavigate } from "react-router-dom";
import { authLogout } from "../api/auth";
import { pubState } from "../recoil/pub.atom";

const LogoutDialog = ({ onClose }: { onClose: () => void }) => {
  const setIsLoggedIn = useSetRecoilState(loginState);
  const navigate = useNavigate();
  const pub = useRecoilValue(pubState);

  const handleLogout = async (isAll: boolean) => {
    if (isAll && pub) {
      try {
        await authLogout(pub.id);
      } catch {}
    }
    clearCredential();
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <GlobalOverlay>
      <S.LogoutDialogWrapper>
        <S.LogoutDialogContent>
          <img src="/image-web/icon/logout.png" alt="logout" />
          <div className="title">로그아웃을 하시겠습니까?</div>
          <div className="description">
            현재 로그인된 계정에서 로그아웃합니다.
            <br />
            모든 기기에서 로그아웃 시 다른 기기에서도 다시 로그인해야 합니다.
          </div>
        </S.LogoutDialogContent>
        <S.LogoutButtonWrapper>
          <S.LogoutCurrentButton onClick={() => handleLogout(false)}>
            현재 기기에서 로그아웃
          </S.LogoutCurrentButton>
          <S.LogoutAllButton onClick={() => handleLogout(true)}>
            모든 기기에서 로그아웃
          </S.LogoutAllButton>
          <S.LogoutCancelButton onClick={onClose}>취소</S.LogoutCancelButton>
        </S.LogoutButtonWrapper>
      </S.LogoutDialogWrapper>
    </GlobalOverlay>
  );
};

export default LogoutDialog;
